import {FiltroTelaUI} from '../../../../projects/loja/src/objeto/FiltroTelaUI';
import {CodigoSegmento, segmentoCrm} from './crm-segmentos';

/**
 * Campanha para um segmento do CRM: o público é um filtro salvo "CRM · <segmento>"
 * (status = código) e a mensagem começa com um texto sugerido que o dono edita.
 * Textos neutros de segmento de mercado, sempre com [NomeContato] e [Link_Cardapio].
 */
export const TEXTO_SUGERIDO_POR_SEGMENTO: {[codigo in CodigoSegmento]: string} = {
  ESFRIANDO: 'Oi [NomeContato], sentimos sua falta por aqui! Que tal matar a saudade de [ProdutoFavorito] hoje? Seu pedido está a um clique: [Link_Cardapio]',
  SUMIDO: '[NomeContato], já faz [DiasSemPedir] que você não pede com a gente. Separamos as novidades do cardápio para você voltar: [Link_Cardapio]',
  NOVO: 'Oi [NomeContato], obrigado pelo seu pedido! Esperamos que tenha gostado. Quando bater a vontade de novo, é só pedir por aqui: [Link_Cardapio]',
  FIEL: '[NomeContato], você já é de casa! Que tal turbinar o [ProdutoFavorito] com os combos e adicionais desta semana? Confira: [Link_Cardapio]',
  CAMPEAO: '[NomeContato], você é um dos nossos clientes mais especiais e queríamos contar a novidade em primeira mão: [Link_Cardapio]',
  PERDIDO: 'Oi [NomeContato], faz tempo! Muita coisa mudou por aqui e queremos te mostrar. Dá uma olhada: [Link_Cardapio]',
  SEM_PEDIDO: 'Oi [NomeContato]! Você já conhece o nosso cardápio online? Fazer o primeiro pedido é rapidinho: [Link_Cardapio]'
};

export function nomeDoFiltroDoSegmento(codigo: string): string {
  return `CRM · ${segmentoCrm(codigo).nome}`;
}

export function nomeSugeridoDaCampanha(codigo: string, hoje: Date = new Date()): string {
  const mes = hoje.toLocaleDateString('pt-BR', {month: 'short'}).replace('.', '');
  return `${segmentoCrm(codigo).nome} · ${hoje.getDate()} ${mes}`;
}

/** Código do segmento quando o filtro é o "CRM · <segmento>" (status com um único valor). */
export function segmentoDoFiltro(filtro: any): string | null {
  const status = filtro && filtro.dados && filtro.dados.status;
  const valor = status && status.valor;
  if (!Array.isArray(valor) || valor.length !== 1) return null;
  return filtro.nome === nomeDoFiltroDoSegmento(valor[0]) ? valor[0] : null;
}

/** Reaproveita o filtro salvo do segmento ou cria um novo; devolve o filtro com id. */
export async function garantaFiltroDoSegmento(usuarioService: any, codigo: string, filtrosCarregados: any[] = null): Promise<any> {
  const nome = nomeDoFiltroDoSegmento(codigo);
  const filtros: any[] = filtrosCarregados || await usuarioService.listeFiltros();
  const existente = (filtros || []).find(f => f.nome === nome);
  if (existente) return existente;
  const status: any = FiltroTelaUI.status();
  status.valor = [codigo];
  const novo: any = {nome, dados: {status}};
  const resposta = await usuarioService.salveFiltro(novo);
  return {...novo, id: resposta.id};
}
